import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import { Colors, Metrics } from '../../Themes'
import Edit from '../../svg-icons/Edit'

const IconWrapper = styled.div`
  position: absolute;
  height: 40px;
  width: 40px;
  bottom: 0;
  left: ${props => props.pictureSize - 40}px;
  backgroundColor: ${Colors.lightGrey};
  outline: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    backgroundColor: ${Colors.darkGrey};
  }

  svg {
    margin-left: 10px;
    margin-top: 10px;
    height: 20px;
    width: 20px;

    g {
      fill-rule: nonzero;
      path:nth-child(3) {
        fill: white;
      }
    }
  }

  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    display: none;
  }
`

const propTypes = {
  onClick: PropTypes.func
}

class EditPictureButton extends Component {
  render () {
    return (
      <IconWrapper onClick={this.props.onClick} {...this.props}>
        <Edit />
      </IconWrapper>
    )
  }
}

EditPictureButton.propTypes = propTypes

export default EditPictureButton



// WEBPACK FOOTER //
// ./src/components/Avatar/EditPictureButton.js